import type { RoleModule } from '../types';
/* General Sans — the kit's face. See the nurse module's note. */
import '@/components/kit/fonts.css';
/* Lane-local overrides, gated on `.acc-root` — see the file. */
import './accountant.css';
import { AccountsHomePage } from './AccountsHomePage';
import { ReceivablesPage } from './ReceivablesPage';
import { BillsPage } from './BillsPage';
import { ExpensesPage } from './ExpensesPage';
import { PeoplePage } from './PeoplePage';
import { StatementPage } from './StatementPage';
import { PayablesPage } from './PayablesPage';
import { TaxPage } from './TaxPage';
import { ProfitLossPage } from './ProfitLossPage';
import { ReportsPage } from './ReportsPage';
import { ExportPage } from './ExportPage';
/* THE MANAGER'S FIVE MONEY REPORTS, MOUNTED HERE. The board calls them "the
   manager's money reports, read-only", so they are the same components on the
   same endpoints rather than a second copy that would drift. */
import { ManagerRevenuePage } from '../clinic-manager/reports/ManagerRevenuePage';
import { ManagerInsurancePage } from '../clinic-manager/reports/ManagerInsurancePage';
import { ManagerEditsPage } from '../clinic-manager/reports/ManagerEditsPage';
import { ManagerChartsPage } from '../clinic-manager/reports/ManagerChartsPage';
import { ManagerTrendsPage } from '../clinic-manager/reports/ManagerTrendsPage';

/**
 * The accountant surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/accountant/`.
 *
 * Ten doors in the design, and all ten are open. The rail draws only the ones
 * that resolve to a route, which is what kept the unfinished ones shut while
 * this lane was being built.
 */
const accountant: RoleModule = {
  routes: [
    { path: '/accountant', element: <AccountsHomePage /> },
    { path: '/accountant/receivables', element: <ReceivablesPage /> },
    { path: '/accountant/bills', element: <BillsPage /> },
    { path: '/accountant/expenses', element: <ExpensesPage /> },
    { path: '/accountant/people', element: <PeoplePage /> },
    { path: '/accountant/people/:personId', element: <StatementPage /> },
    { path: '/accountant/payables', element: <PayablesPage /> },
    { path: '/accountant/tax', element: <TaxPage /> },
    { path: '/accountant/pnl', element: <ProfitLossPage /> },
    { path: '/accountant/reports', element: <ReportsPage /> },
    { path: '/accountant/export', element: <ExportPage /> },
    { path: '/accountant/reports/revenue', element: <ManagerRevenuePage /> },
    { path: '/accountant/reports/insurance', element: <ManagerInsurancePage /> },
    { path: '/accountant/reports/edits', element: <ManagerEditsPage /> },
    { path: '/accountant/reports/charts', element: <ManagerChartsPage /> },
    { path: '/accountant/reports/trends', element: <ManagerTrendsPage /> },
  ],
  doorRoutes: {
    accounts: '/accountant',
    receivables: '/accountant/receivables',
    bills: '/accountant/bills',
    expenses: '/accountant/expenses',
    people: '/accountant/people',
    payables: '/accountant/payables',
    tax: '/accountant/tax',
    pnl: '/accountant/pnl',
    reports: '/accountant/reports',
    export: '/accountant/export',
  },
};

export default accountant;
